export default __webpack_public_path__ + "static/media/bubble1.8b392362.svg";